import React from 'react';
import { Code, Terminal, Database, Wrench, Cloud, Globe } from 'lucide-react';

const Skills = () => {
  const skillCategories = [
    {
      icon: <Code size={32} />,
      title: 'Frontend Development',
      skills: ['React', 'JavaScript (ES6+)', 'TypeScript', 'HTML5 & CSS3', 'Tailwind CSS', 'Redux', 'Next.js']
    },
    {
      icon: <Terminal size={32} />,
      title: 'Backend Development',
      skills: ['Node.js', 'Express.js', 'REST APIs',]
    },
    {
      icon: <Database size={32} />,
      title: 'Database & Storage',
      skills: ['MongoDB','MySQL',]
    },
    {
      icon: <Wrench size={32} />,
      title: 'Tools & Technologies',
      skills: ['Git & GitHub', 'Docker','Vite', 'NPM']
    },
    {
      icon: <Cloud size={32} />,
      title: 'Cloud & DevOps',
      skills: ['AWS', 'Vercel',]
    },
    {
      icon: <Globe size={32} />,
      title: 'Other Skills',
      skills: ['Responsive Design', 'Web Performance','Agile/Scrum', 'UI/UX Principles']
    }
  ];

  return (
    <section id="skills" className="skills-section slide-in-section">
      <div className="container">
        <div className="section-header">
          <span className="section-number">03</span>
          <h2 className="section-title">SKILLS & EXPERTISE</h2>
          <p className="section-subtitle">Technologies and tools I work with</p>
        </div>

        <div className="skills-grid">
          {skillCategories.map((category, idx) => (
            <div key={idx} className="skill-card">
              <div className="skill-header">
                <div className="skill-icon">{category.icon}</div>
                <h3 className="skill-title">{category.title}</h3>
              </div>
              <div className="skill-tags">
                {category.skills.map((skill, i) => (
                  <span key={i} className="skill-tag">{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;